module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "first"
    }
  }, [_c('span', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-document"
  }), _vm._v("Manage delivery")]), _vm._v(" "), _c('keep-alive', [(_vm.activeName === 'first') ? _c('Tablecontent') : _vm._e()], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "second"
    }
  }, [_c('span', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v("Create activity")]), _vm._v(" "), _c('keep-alive', [(_vm.activeName === 'second') ? _c('Formcontent') : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fda2d2c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Tabs/index.vue
// module id = 772
// module chunks = 2